export function getElementData(element, prefix = '') {
    var attrs = element.attributes;
    var data = {};

    if('dataset' in element) {
        attrs = element.dataset;
    } else {
        prefix = 'data-' + prefix;
    }

    Object.keys(attrs).forEach((key) => {
        let attr = attrs[key];
        if(prefix.length == 0 || key.indexOf(prefix) == 0) {
            key = key.substr(prefix.length);
            let val = (typeof attr == 'object' && ('nodeValue' in attr)) ? attr.nodeValue : attr;
            if(!isNaN(val)) {
                val = +val;
            }
            data[key] = val;
        }
    });

    return data;
}

export function on(target, listenClass, eventName, handler) {
    target.addEventListener(eventName, (e) => {
        target = e.target;

        while (target && target.parentElement !== document) {
            target = target.parentElement;
            if(!target) { return; }

            if(target.classList.contains(listenClass)){
                handler(target, e);
                return;
            }
        }
    });
}

export function parentByClass(source, searchClass, stopAt = null, includeSelf = false) {
    if(!includeSelf) {
        source = source.parentElement;
    }

    while(source && source !== document) {
        if(source.classList.contains(searchClass)) {
            return source;
        } else if(stopAt && stopAt == source) {
            break;
        }

        source = source.parentElement;
    } 

    return null;
}

export function childIndex(child) {
    var  i= 0;

    while((child = child.previousSibling) != null) {
        ++i;
    }

    return i;
}